import { LegacyCard, LegacyStack, Text } from "@shopify/polaris";
import { Subheading } from "../..";
import { ToggleSwitch } from "@vendor-app/app/AdminRoute/AdminLoyaltyRoute/components/ToggleSwitch";

interface OutOfStockItemRemovalEnabledSettingProps {
  outOfStockItemRemovalEnabled: boolean;
  setOutOfStockItemRemovalEnabled: React.Dispatch<React.SetStateAction<boolean | null | undefined>>;
}

export function OutOfStockItemRemovalEnabledSetting({
  outOfStockItemRemovalEnabled,
  setOutOfStockItemRemovalEnabled,
}: OutOfStockItemRemovalEnabledSettingProps) {
  return (
    <LegacyCard.Section>
      <LegacyStack>
        <Text as="h3" variant="headingSm">
          Out of stock item removal
        </Text>
        <ToggleSwitch
          defaultToggled={outOfStockItemRemovalEnabled}
          onHandleChangeCB={v => {
            setOutOfStockItemRemovalEnabled(v);
          }}
        />
      </LegacyStack>
      <Subheading className="card-subheading">
        {
          "When enabled, any out-of-stock items will be automatically moved to the customer's next order, while the rest of the shipment continues as planned. Customers will be notified, and you will see a record in the subscription log."
        }
      </Subheading>
    </LegacyCard.Section>
  );
}
